module.exports = __webpack_public_path__ + "fonts/8b1093b47847dd70fc6d6b480813716a.svg";